import { render, staticRenderFns } from "./CustomLocationModal.vue?vue&type=template&id=638a70e4&scoped=true"
import script from "./CustomLocationModal.vue?vue&type=script&lang=js"
export * from "./CustomLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a70e4",
  null
  
)

export default component.exports